// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__3Z9Vo","button_submit":"button_button_submit__2Cc9n","button_back":"button_button_back__8aFEB"};